import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces the window back to the top on EVERY route change and on full page
 * load. Uses three layered strategies because AnimatePresence can leave the
 * outgoing page in the DOM briefly, and some browsers attempt scroll
 * restoration after the route swap.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser auto scroll-restoration once on mount
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // Also reset on initial load
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // 1) Synchronous reset
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // 2) After paint (covers AnimatePresence mount delay)
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    // 3) After exit/enter animation settles (~600ms)
    const t = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 80);

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [pathname]);

  return null;
}
